import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=5f44e3ec&scoped=true"
import script from "./checkout.ts?vue&type=script&lang=ts&external"
export * from "./checkout.ts?vue&type=script&lang=ts&external"
import style0 from "./checkout.scss?vue&type=style&index=0&id=5f44e3ec&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f44e3ec",
  null
  
)

export default component.exports